import type { GetStaticProps, NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import dynamic from 'next/dynamic';
import { MetaData } from '@/components/MetaData';

const GetMyDemo = dynamic<{}>(
  () => import('@/features/demo').then((module) => module.Demo),
  {
    ssr: false,
  },
);

const DemoPage: NextPage = () => {
  return (
    <>
      <MetaData />
      <GetMyDemo />
    </>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      ...(await serverSideTranslations('en', ['common', 'metaData', 'demo'])),
    },
  };
};

export default DemoPage;
